import { render, staticRenderFns } from "./ChatItemSendStatus.vue?vue&type=template&id=d2dd243a&scoped=true&"
import script from "./ChatItemSendStatus.vue?vue&type=script&lang=js&"
export * from "./ChatItemSendStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChatItemSendStatus.vue?vue&type=style&index=0&id=d2dd243a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dd243a",
  null
  
)

export default component.exports